import Vue from 'vue'
import { jwtVerify, importSPKI } from 'jose'
import consoleLog from './consoleLog.js'

export let isSubscriber = false

const spkiPublicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqzp7z7KJF9wTLQNlJGPm
g7aKqOFZnfSUgcH7H7Qhcbq8W5C2VbLBqV9ZnrJqn7EEQUr3jjCVPxPvJLqGLVyH
ZBaHLQUJmVpQdvD4s6h3sC6Hg0KvPzxPL4ydJdJlLqMPfJV3H5L3J8M8fqJfJ8fL
8fL8f8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8f
L8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL
8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8
fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fL8fIDAQAB
-----END PUBLIC KEY-----`

export async function isAuthorised() {
  const token = new URLSearchParams(window.location.search).get('token')
  if (!token) {
    return false
  }

  try {
    const publicKey = await importSPKI(spkiPublicKey, 'RS256')
    await jwtVerify(token, publicKey)
    consoleLog('Token is valid')
    isSubscriber = true
    return true
  } catch (err) {
    consoleLog('Token is invalid', err)
    Vue.config.gruErrorStatus = 'Invalid token'
    return false
  }
}

export function canAccessContent(topicKey) {
  return isSubscriber || topicKey === 'animals'
}

isAuthorised()
